import { createGlobalStyle } from 'styled-components';
import Color from '../enums/color';
const GlobalStyle = createGlobalStyle `
  * {
    font-family: 'Roboto';
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }
  
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }
  
  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: ${Color.OceanBlue};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${Color.Grey85};
  }

  .ant-picker-dropdown.today-not-highlighted {
    .ant-picker-cell-in-view.ant-picker-cell-today {
      .ant-picker-cell-inner::before {
        border: none;
      }
    }
  }

  .modal-spinner-container {
    .ant-spin-blur {
      opacity: 1;
    }

    & > div > .ant-spin {
      max-height: 100%;
    }
  }
`;
export default GlobalStyle;
